export default "__VITE_ASSET__XR1izpku__"